export default __webpack_public_path__ + "static/media/ozzylogo.737ddcd3.png";